import { render, staticRenderFns } from "./TrustBanner.vue?vue&type=template&id=611dd5d3&"
import script from "./TrustBanner.vue?vue&type=script&lang=js&"
export * from "./TrustBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports